export default {
  data() {
    return {
      bandeiras: [],
    };
  },
  methods: {
    async getBandeirasPadrao() {
      try {
        const { data: bandeiras } = await this.$http.post('/inventory.get-flag-fixed');
        return bandeiras.map((item) => ({
          ...item,
          name: item.name,
        }));
      } catch (err) {
        return [];
      }
    },
    async getBandeirasPorUsuario() {
      try {
        const { data: bandeiras } = await this.$http.post('/inventory.get-flag', { isPDV: true });
        return bandeiras.map((item) => ({
          ...item,
          name: item.name,
        }));
      } catch (err) {
        return [];
      }
    },
    async getBandeiras() {
      this.bandeiras = [
        ...await this.getBandeirasPadrao(),
        ...await this.getBandeirasPorUsuario(),
      ];
    },
  },
};
